exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wl-container[data-v-d274cae4] {\n  height: 100%;\n  background: #f0f0f0;\n  padding: 0.0625rem;\n}\n.center[data-v-d274cae4] {\n  background-color: #fff;\n  padding-bottom: 0.104167rem;\n}\n.top-btn[data-v-d274cae4] {\n  text-align: right;\n  margin-top: 0.052083rem;\n}\n.title[data-v-d274cae4] {\n  font-weight: 700;\n  font-style: normal;\n  font-size: 0.083333rem;\n  color: #696969;\n  line-height: 0.208333rem;\n  padding: 0.041667rem 0 0.041667rem 0.052083rem;\n}", ""]);

// exports
